import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { ErrorOutline } from '@material-ui/icons';
import { v4 as uuidV4 } from 'uuid';

import './style.scss';
import { ButtonLounge } from '../button/button-louge';
import { InfoAwesomeIcon } from 'app/shared/icons';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  })
);

const TransitionsModal = ({ showModal, textBody = '', ArrayMessage = [], setShowModel, handleOptionalFunction }: any) => {

  const classes = useStyles();


  const handleClose = () => {
    if (handleOptionalFunction) {
      handleOptionalFunction();
    } else {
      setShowModel(false);
    }
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={"modal-container"}
      open={showModal}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={showModal}>
        <div className="paper-info">
          <InfoAwesomeIcon />
          <div className="paper-info-text">{textBody}</div>
          <br />
          <br />
          <div className='desktop-popup-btn pt-1'>
            <ButtonLounge title={'OK'} action={handleClose} style={'1'} />
          </div>
        </div>
      </Fade>
    </Modal>
  );
};

export default TransitionsModal;
